export enum AppRoutes {
  LoginForm = 'login-form',
  Agents = 'agents',
  Agencies = 'agencies',
  Prospects = 'prospects',
  Carriers = 'carriers',
  Campaign = 'campaign',
  Registrants = 'registrants',
  Administration = 'administration',
  NotificationsHub = 'notifications-hub',
  Home = 'home',
  Dashboard = 'dashboard',
  Profile = 'profile',
  Logout = 'logout',
  Webinars = 'webinars',
  Contests = 'contests',
  Forms = 'forms-list',
  DistributionLists = 'distribution-lists',
  EmailTemplates = 'email-templates',
  ConferenceRegistrations = 'conference-registrations',
  RegistrationReports = 'registration-reports',
  ConferencePostersList = 'conference-posters-list',
  Events = 'events',
  AccessDenied = 'access-denied',
  CarriersProductionReporting = 'carriers-production-reporting',
  AgentRegistry = 'agent-registry',
  DownlineImports = 'downline-imports',
  ReportsViewer = 'reports-viewer',
  TempReact = 'temp-react',
}
